import { createReducer } from '@reduxjs/toolkit';
import {
  ICancelShiftState,
  IFacilityShiftListState,
  IOngoingShiftListState,
  IShiftDetailsState,
  IShiftHistoryState,
  IShiftStatisticsState,
  ITodayShiftStatisticsState,
  IUpdateShiftAttendanceState,
  IForceCancelShiftState,
  IOrganizationClockInState,
  IOrganizationClockOutState,
  IMonitoringShiftState,
  IShiftRequestListState,
  IFacilityShiftRequestListState,
  IUpdateShiftRequestStatusState,
  ICompleteShiftRequestState,
  ICancelShiftRequestState,
  ICancellationWarningState,
  IValidateWorkerShiftTimingState,
  IShiftBoardStatsState,
} from './types';
import {
  fetchFacilityShiftList,
  fetchAllShifts,
  fetchShiftStatistics,
  fetchTodayShiftStatistics,
  fetchShiftDetails,
  cancelShift,
  updateShiftAttendance,
  organizationActionOnShiftAttendance,
  fetchOngoingShifts,
  forceCancelShift,
  fetchMonitoringShifts,
  fetchShiftRequests,
  fetchFacilityShiftRequests,
  updateShiftRequestStatus,
  completeShiftRequest,
  cancelShiftRequest,
  resetUpdateShiftRequestStatus,
  resetCompleteShiftRequest,
  resetCancelShiftRequest,
  fetchCancellationWarning,
  validateWorkerShiftTiming,
  fetchShiftBoardStats,
  resetUpdateShiftAttendance,
  fetchOrgFacilityPendingShifts,
  bulkOrganizationApproveAttendance,
  organizationClockIn,
  organizationClockOut,
  resetForceCancelShift,
  resetOrganizationClockIn,
  resetOrganizationClockOut,
} from './actions';

const initialOngoingShiftListState: IOngoingShiftListState = {
  loading: false,
  list: {
    results: [],
    count: 0,
    next: null,
    previous: null,
  },
  error: null,
};

export const ongoingShiftsReducer = createReducer(
  initialOngoingShiftListState,
  (builder) => {
    builder
      .addCase(fetchOngoingShifts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOngoingShifts.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchOngoingShifts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialShiftDetailsState: IShiftDetailsState = {
  loading: false,
  data: null,
  error: null,
};


export const shiftDetailsReducer = createReducer(
  initialShiftDetailsState,
  (builder) => {
    builder
      .addCase(fetchShiftDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchShiftDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialTodayShiftStatisticsState: ITodayShiftStatisticsState = {
  loading: false,
  statistics: {
    total_shift_created_today: 0,
    todays_total_active_shift: 0,
    attendance_in_percentage: 0,
  },
  error: null,
};

const initialShiftStatisticsState: IShiftStatisticsState = {
  loading: false,
  statistics: {
    total_shifts: 0,
    assigned_fulfilment_rate: 0,
    total_fulfilment_rate: 0,
    attendance_compliance: 0,
    flagged_worker_count: 0,
  },
  error: null,
};

export const todayShiftStatisticsReducer = createReducer(
  initialTodayShiftStatisticsState,
  (builder) => {
    builder
      .addCase(fetchTodayShiftStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTodayShiftStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
      })
      .addCase(fetchTodayShiftStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialFacilityShiftListState: IFacilityShiftListState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};
export const shiftStatisticsReducer = createReducer(
  initialShiftStatisticsState,
  (builder) => {
    builder
      .addCase(fetchShiftStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
      })
      .addCase(fetchShiftStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);
const initialAllShiftsState: IShiftHistoryState = {
  loading: false,
  count: 0,
  next: null,
  previous: null,
  results: [],
  error: null,
};

export const facilityShiftListReducer = createReducer(initialFacilityShiftListState, (builder) => {
  builder
    .addCase(fetchFacilityShiftList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityShiftList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchFacilityShiftList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const orgFacilityPendingShiftsReducer = createReducer(initialFacilityShiftListState, (builder) => {
  builder
    .addCase(fetchOrgFacilityPendingShifts.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchOrgFacilityPendingShifts.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchOrgFacilityPendingShifts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

export const allShiftsReducer = createReducer(initialAllShiftsState, (builder) => {
  builder
    .addCase(fetchAllShifts.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.results = [];
      state.count = 0;
    })
    .addCase(fetchAllShifts.fulfilled, (state, action) => {
      state.loading = false;
      state.count = action.payload.count;
      state.next = action.payload.next;
      state.previous = action.payload.previous;
      state.results = action.payload.results;
    })
    .addCase(fetchAllShifts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.results = [];
      state.count = 0;
    });
});

const initialCancelShiftState: ICancelShiftState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const cancelShiftReducer = createReducer(
  initialCancelShiftState,
  (builder) => {
    builder
      .addCase(cancelShift.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(cancelShift.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(cancelShift.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
);

const initialUpdateShiftAttendanceState: IUpdateShiftAttendanceState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const updateShiftAttendanceReducer = createReducer(
  initialUpdateShiftAttendanceState,
  (builder) => {
    builder
      .addCase(updateShiftAttendance.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(updateShiftAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(updateShiftAttendance.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(organizationActionOnShiftAttendance.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(organizationActionOnShiftAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(organizationActionOnShiftAttendance.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(bulkOrganizationApproveAttendance.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(bulkOrganizationApproveAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(bulkOrganizationApproveAttendance.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(resetUpdateShiftAttendance, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialForceCancelShiftState: IForceCancelShiftState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const forceCancelShiftReducer = createReducer(
  initialForceCancelShiftState,
  (builder) => {
    builder
      .addCase(forceCancelShift.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(forceCancelShift.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(forceCancelShift.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        if (action.payload && typeof action.payload === 'object' && 'message' in action.payload) {
          state.message = (action.payload as any).message;
        } else {
          state.message = null;
        }
      })
      .addCase(resetForceCancelShift, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialOrganizationClockInState: IOrganizationClockInState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const organizationClockInReducer = createReducer(
  initialOrganizationClockInState,
  (builder) => {
    builder
      .addCase(organizationClockIn.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(organizationClockIn.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(organizationClockIn.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(resetOrganizationClockIn, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialOrganizationClockOutState: IOrganizationClockOutState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const organizationClockOutReducer = createReducer(
  initialOrganizationClockOutState,
  (builder) => {
    builder
      .addCase(organizationClockOut.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(organizationClockOut.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(organizationClockOut.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(resetOrganizationClockOut, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialMonitoringShiftsState: IMonitoringShiftState = {
  loading: false,
  data: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  error: null,
};

export const monitoringShiftsReducer = createReducer(
  initialMonitoringShiftsState,
  (builder) => {
    builder
      .addCase(fetchMonitoringShifts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonitoringShifts.fulfilled, (state, action) => {
        state.loading = false;
        if (action.meta.arg.page && action.meta.arg.page > 1) {
          state.data.results = [...state.data.results, ...action.payload.results];
          state.data.next = action.payload.next;
          state.data.previous = action.payload.previous;
          // count remains the same or updates
          state.data.count = action.payload.count;
        } else {
          state.data = action.payload;
        }
        state.error = null;
      })
      .addCase(fetchMonitoringShifts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialShiftRequestListState: IShiftRequestListState = {
  loading: false,
  list: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  error: null,
};

export const shiftRequestsReducer = createReducer(
  initialShiftRequestListState,
  (builder) => {
    builder
      .addCase(fetchShiftRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        state.error = null;
      })
      .addCase(fetchShiftRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialFacilityShiftRequestListState: IFacilityShiftRequestListState = {
  loading: false,
  list: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  error: null,
};

export const facilityShiftRequestsReducer = createReducer(
  initialFacilityShiftRequestListState,
  (builder) => {
    builder
      .addCase(fetchFacilityShiftRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFacilityShiftRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        state.error = null;
      })
      .addCase(fetchFacilityShiftRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialUpdateShiftRequestStatusState: IUpdateShiftRequestStatusState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const updateShiftRequestStatusReducer = createReducer(
  initialUpdateShiftRequestStatusState,
  (builder) => {
    builder
      .addCase(updateShiftRequestStatus.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(updateShiftRequestStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(updateShiftRequestStatus.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(resetUpdateShiftRequestStatus, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialCompleteShiftRequestState: ICompleteShiftRequestState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const completeShiftRequestReducer = createReducer(
  initialCompleteShiftRequestState,
  (builder) => {
    builder
      .addCase(completeShiftRequest.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(completeShiftRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(completeShiftRequest.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(resetCompleteShiftRequest, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialCancelShiftRequestState: ICancelShiftRequestState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const cancelShiftRequestReducer = createReducer(
  initialCancelShiftRequestState,
  (builder) => {
    builder
      .addCase(cancelShiftRequest.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(cancelShiftRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(cancelShiftRequest.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      })
      .addCase(resetCancelShiftRequest, (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
        state.message = null;
      });
  },
);

const initialCancellationWarningState: ICancellationWarningState = {
  loading: false,
  data: null,
  error: null,
};

export const cancellationWarningReducer = createReducer(
  initialCancellationWarningState,
  (builder) => {
    builder
      .addCase(fetchCancellationWarning.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(fetchCancellationWarning.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCancellationWarning.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialValidateWorkerShiftTimingState: IValidateWorkerShiftTimingState = {
  loading: false,
  data: null,
  error: null,
};

export const validateWorkerShiftTimingReducer = createReducer(
  initialValidateWorkerShiftTimingState,
  (builder) => {
    builder
      .addCase(validateWorkerShiftTiming.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(validateWorkerShiftTiming.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(validateWorkerShiftTiming.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialShiftBoardStatsState: IShiftBoardStatsState = {
  loading: false,
  data: null,
  error: null,
};

export const shiftBoardStatsReducer = createReducer(
  initialShiftBoardStatsState,
  (builder) => {
    builder
      .addCase(fetchShiftBoardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShiftBoardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Payload is now IShiftBoardStats
        state.error = null;
      })
      .addCase(fetchShiftBoardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);
